import { FETCH_NATIONALITIES,START_LOADING ,END_LOADING} from "../actions/constants";

const nationalitiesReducer = (
  state = { isLoading: true, nationalities: [] },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_NATIONALITIES:
      return {
        ...state,
        nationalities: action.payload,
      };

    default:
      return state;
  }
};

export default nationalitiesReducer;
